import Packaging from './packaging';

function options(): any[] {
  return Object.entries(Packaging).map(([key, value]) => (
    { value: key, label: `${key} - ${value}`, text: value })
  );
}

export default options;
